// extracted by mini-css-extract-plugin
export var lbContainerOuter = "v_sJ";
export var lbContainerInner = "v_sK";
export var movingForwards = "v_sL";
export var movingForwardsOther = "v_sM";
export var movingBackwards = "v_sN";
export var movingBackwardsOther = "v_sP";
export var lbImage = "v_sQ";
export var lbOtherImage = "v_sR";
export var prevButton = "v_sS";
export var nextButton = "v_sT";
export var closing = "v_sV";
export var appear = "v_sW";